import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "../../store";
import service from "../../services/api.service";
import { Guid } from "guid-typescript";
import * as _ from "lodash";
import { plainToClass } from "class-transformer";
import { getTenantId } from "@/store/helper";
//List
import { EmployeeGridViewModel } from "../../store/models/employees/employee";
import { EmployeeModel } from "../models/employees/addEmployee";
import { EmployeeDetailViewModel } from "../models/employees/employeeDetailView";
import { EmployeeSearchDataModel, IEmployeeSearchDataListingDTO } from "../models/employees/employeeSearchListingDTO";
import { DesignationModel } from "../models/designation/designationDTO";
import { GuidItemModel } from "../models/shared/guidItem";
let EmployeeModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    let EmployeeModule = class EmployeeModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.Employees = [];
            this.apiNode = "Employee";
            this.employee = null;
            this.users = [];
            this.designations = [];
            this.searchParams = null;
            this.ExternalApiStatuses = [];
            this.ExternalApiProvider = null;
        }
        //Actions
        //List
        async GetAllEmployees(searchData) {
            var url = `${getTenantId()}/${this.apiNode}/employees`;
            let { data } = await service.post(url, searchData);
            if (data) {
                this.ListEmployees(plainToClass(EmployeeGridViewModel, data.employees));
                this.ListDesignations(plainToClass(DesignationModel, data.designations));
                this.ListUsers(plainToClass(GuidItemModel, data.users));
                this.ListExternalApiProvider(plainToClass(GuidItemModel, data.externalApiProvider));
                return data;
            }
        }
        async DeleteEmployee(empId) {
            var url = `${getTenantId()}/${this.apiNode}/delete/` + empId;
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        async DeactivateEmployee(empId) {
            var url = `${getTenantId()}/${this.apiNode}/deactivate/` + empId;
            let { data } = await service.put(url);
            if (data) {
                return data;
            }
        }
        //Mutations
        ListEmployees(Employee) {
            this.Employees = Employee;
        }
        ListExternalApiProvider(externalApiProvider) {
            this.ExternalApiProvider = externalApiProvider;
        }
        ListExternalApiSyncStatus(externalApiStatuses) {
            this.ExternalApiStatuses = externalApiStatuses;
        }
        ListDesignations(designations) {
            this.designations = designations;
        }
        ListUsers(users) {
            this.users = users;
        }
        //Add
        async SaveEmployee(employee) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, employee);
            return data;
        }
        //View
        async ViewEmployee(employeeId) {
            var url = `${getTenantId()}/${this.apiNode}/` + employeeId;
            let { data } = await service.get(url);
            if (data) {
                this.ViewEmployees(plainToClass(EmployeeDetailViewModel, data.employee));
                return data;
            }
        }
        //Mutations
        ViewEmployees(employee) {
            this.employee = employee;
        }
        //Update
        async GetEmployeeDetailById(employeeId) {
            var url = `${getTenantId()}/${this.apiNode}/` + employeeId + `/Edit`;
            let { data } = await service.get(url);
            if (data) {
                this.EditEmployee(plainToClass(EmployeeDetailViewModel, data.employee));
                return data;
            }
        }
        EditEmployee(employee) {
            this.employee = employee;
        }
        async UpdateEmployee(updateEmployee) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.put(url, updateEmployee);
            return data;
        }
        // Excel Export for  Listing page
        async GetEmployeesExcelExport() {
            var url = `${getTenantId()}/${this.apiNode}/Excel/ExportEmployees`;
            let { data } = await service.get(url, { responseType: "blob" });
            return data;
        }
        // Pdf Generator for employee
        // View
        async GeneratePdfById(employeeId) {
            var url = `${getTenantId()}/${this.apiNode}/pdf/` + employeeId;
            let { data } = await service.get(url, { responseType: "blob" });
            return data;
        }
        async GetExternalApiStatusDetails() {
            var url = `${getTenantId()}/${this.apiNode}/provider`;
            let { data } = await service.get(url);
            if (data) {
                this.ListExternalApiSyncStatus(plainToClass(GuidItemModel, data.externalApiStatuses));
            }
            return data;
        }
        async SyncDetailsFromExternalApi(externalApiId) {
            var url = `${getTenantId()}/${this.apiNode}/externalAPISync/` + externalApiId;
            let { data } = await service.get(url);
            return data;
        }
        AssignSearchParams(params) {
            this.searchParams = _.cloneDeep(params);
        }
        ClearSearchParams() {
            this.searchParams = null;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof IEmployeeSearchDataListingDTO !== "undefined" && IEmployeeSearchDataListingDTO) === "function" ? _a : Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], EmployeeModule.prototype, "GetAllEmployees", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof Guid !== "undefined" && Guid) === "function" ? _c : Object]),
        __metadata("design:returntype", Promise)
    ], EmployeeModule.prototype, "DeleteEmployee", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof Guid !== "undefined" && Guid) === "function" ? _d : Object]),
        __metadata("design:returntype", Promise)
    ], EmployeeModule.prototype, "DeactivateEmployee", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], EmployeeModule.prototype, "ListEmployees", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof GuidItemModel !== "undefined" && GuidItemModel) === "function" ? _e : Object]),
        __metadata("design:returntype", void 0)
    ], EmployeeModule.prototype, "ListExternalApiProvider", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], EmployeeModule.prototype, "ListExternalApiSyncStatus", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], EmployeeModule.prototype, "ListDesignations", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], EmployeeModule.prototype, "ListUsers", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof EmployeeModel !== "undefined" && EmployeeModel) === "function" ? _f : Object]),
        __metadata("design:returntype", Promise)
    ], EmployeeModule.prototype, "SaveEmployee", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], EmployeeModule.prototype, "ViewEmployee", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof EmployeeDetailViewModel !== "undefined" && EmployeeDetailViewModel) === "function" ? _h : Object]),
        __metadata("design:returntype", void 0)
    ], EmployeeModule.prototype, "ViewEmployees", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], EmployeeModule.prototype, "GetEmployeeDetailById", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_k = typeof EmployeeDetailViewModel !== "undefined" && EmployeeDetailViewModel) === "function" ? _k : Object]),
        __metadata("design:returntype", void 0)
    ], EmployeeModule.prototype, "EditEmployee", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_l = typeof EmployeeDetailViewModel !== "undefined" && EmployeeDetailViewModel) === "function" ? _l : Object]),
        __metadata("design:returntype", Promise)
    ], EmployeeModule.prototype, "UpdateEmployee", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_m = typeof Promise !== "undefined" && Promise) === "function" ? _m : Object)
    ], EmployeeModule.prototype, "GetEmployeesExcelExport", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", typeof (_o = typeof Promise !== "undefined" && Promise) === "function" ? _o : Object)
    ], EmployeeModule.prototype, "GeneratePdfById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_p = typeof Promise !== "undefined" && Promise) === "function" ? _p : Object)
    ], EmployeeModule.prototype, "GetExternalApiStatusDetails", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_q = typeof Promise !== "undefined" && Promise) === "function" ? _q : Object)
    ], EmployeeModule.prototype, "SyncDetailsFromExternalApi", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_r = typeof EmployeeSearchDataModel !== "undefined" && EmployeeSearchDataModel) === "function" ? _r : Object]),
        __metadata("design:returntype", void 0)
    ], EmployeeModule.prototype, "AssignSearchParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], EmployeeModule.prototype, "ClearSearchParams", null);
    EmployeeModule = __decorate([
        Module({ dynamic: true, store: store, name: "employees", namespaced: true })
    ], EmployeeModule);
    return EmployeeModule;
})();
export default getModule(EmployeeModule);
